<div class="flex justify-between items-center mb-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">{{ isEditMode ? 'Edição' : 'Cadastro' }} de Ordem de Serviço</h1>
    </div>
</div>

<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto bg-white">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    
    <!-- Tabs -->
    <p-tabview [(activeIndex)]="activeTabIndex">
      
      <!-- Aba 1: Dados -->
      <p-tabpanel header="Dados">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4">
          
          <div class="md:col-span-2">
            <label class="block mb-1 font-medium">Cliente <span class="text-red-500">*</span></label>
            <p-dropdown
              [options]="customers"
              formControlName="customerId"
              optionLabel="fullName"
              optionValue="id"
              [filter]="true"
              filterBy="fullName"
              placeholder="Selecione um cliente"
              class="w-full"
              styleClass="w-full"
            ></p-dropdown>
          </div>

          <div>
            <label class="block mb-1 font-medium">Data <span class="text-red-500">*</span></label>
            <p-datepicker 
              formControlName="date" 
              dateFormat="dd/mm/yy" 
              [showTime]="true"
              styleClass="w-full"
              class="w-full"
            ></p-datepicker>
          </div>

          <div>
            <label class="block mb-1 font-medium">Status <span class="text-red-500">*</span></label>
            <p-dropdown
              [options]="statusOptions"
              formControlName="status"
              optionLabel="label"
              optionValue="value"
              class="w-full"
              styleClass="w-full"
            ></p-dropdown>
          </div>

          <div class="md:col-span-4">
            <label class="block mb-1 font-medium">Observação</label>
            <textarea 
              pTextarea 
              formControlName="observation" 
              rows="3" 
              class="w-full"
            ></textarea>
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 2: Checklist -->
      <p-tabpanel header="Checklist">
        <div class="mt-4">
          <div class="flex justify-between items-center mb-4">
            <div class="flex items-center gap-3">
              <h3 class="text-lg font-semibold text-gray-700">Itens do Checklist</h3>
              <span class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                {{ checklistItems.length }} {{ checklistItems.length === 1 ? 'item' : 'itens' }}
              </span>
              <span *ngIf="checklistItems.length > 0" class="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                {{ checkedItemsCount }} {{ checkedItemsCount === 1 ? 'concluído' : 'concluídos' }}
              </span>
            </div>
            <button 
              pButton 
              type="button" 
              icon="pi pi-plus" 
              label="Adicionar Item" 
              class="p-button-sm p-button-outlined" 
              (click)="addChecklistItem()"
            ></button>
          </div>

          <!-- Layout em duas colunas com scroll -->
          <div class="max-h-[600px] overflow-y-auto pr-2">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div 
                *ngFor="let item of checklistItems; let i = index" 
                class="flex items-center gap-3 p-3 bg-gray-50 rounded hover:bg-gray-100 transition-colors"
              >
                <p-checkbox 
                  [(ngModel)]="item.checked" 
                  [ngModelOptions]="{standalone: true}"
                  [binary]="true"
                ></p-checkbox>
                
                <input 
                  type="text" 
                  pInputText 
                  [(ngModel)]="item.text" 
                  [ngModelOptions]="{standalone: true}"
                  placeholder="Digite o item do checklist"
                  class="flex-1"
                />
                
                <button 
                  pButton 
                  type="button" 
                  icon="pi pi-trash" 
                  class="p-button-rounded p-button-danger p-button-text" 
                  (click)="removeChecklistItem(i)"
                ></button>
              </div>
            </div>

            <!-- Mensagem quando vazio -->
            <div *ngIf="checklistItems.length === 0" class="text-center text-gray-500 py-8">
              Nenhum item no checklist. Clique em "Adicionar Item" para começar.
            </div>
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 3: Informações -->
      <p-tabpanel header="Informações">
        <div class="mt-4">
          <!-- Área scrollable com altura máxima -->
          <div class="max-h-[600px] overflow-y-auto pr-2">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <ng-container *ngFor="let field of customFieldDefinitions">
                
                <!-- TEXT -->
                <div *ngIf="field.fieldType === 'TEXT'">
                  <label class="block mb-1 font-medium">
                    {{ field.label }}
                    <span *ngIf="field.required" class="text-red-500">*</span>
                  </label>
                  <input 
                    type="text" 
                    pInputText 
                    [(ngModel)]="customFieldsMap[field.id]"
                    [ngModelOptions]="{standalone: true}"
                    class="w-full"
                  />
                </div>

                <!-- NUMBER -->
                <div *ngIf="field.fieldType === 'NUMBER'">
                  <label class="block mb-1 font-medium">
                    {{ field.label }}
                    <span *ngIf="field.required" class="text-red-500">*</span>
                  </label>
                  <p-inputNumber
                    [(ngModel)]="customFieldsMap[field.id]"
                    [ngModelOptions]="{standalone: true}"
                    class="w-full"
                    [inputStyle]="{ width: '100%' }"
                  ></p-inputNumber>
                </div>

                <!-- DATE -->
                <div *ngIf="field.fieldType === 'DATE'">
                  <label class="block mb-1 font-medium">
                    {{ field.label }}
                    <span *ngIf="field.required" class="text-red-500">*</span>
                  </label>
                  <p-datepicker
                    [(ngModel)]="customFieldsMap[field.id]"
                    [ngModelOptions]="{standalone: true}"
                    dateFormat="dd/mm/yy"
                    styleClass="w-full"
                    class="w-full"
                  ></p-datepicker>
                </div>

                <!-- TEXTAREA -->
                <div *ngIf="field.fieldType === 'TEXTAREA'" class="md:col-span-2">
                  <label class="block mb-1 font-medium">
                    {{ field.label }}
                    <span *ngIf="field.required" class="text-red-500">*</span>
                  </label>
                  <textarea 
                    pTextarea 
                    [(ngModel)]="customFieldsMap[field.id]"
                    [ngModelOptions]="{standalone: true}"
                    rows="3" 
                    class="w-full"
                  ></textarea>
                </div>

                <!-- DROPDOWN -->
                <div *ngIf="field.fieldType === 'DROPDOWN'">
                  <label class="block mb-1 font-medium">
                    {{ field.label }}
                    <span *ngIf="field.required" class="text-red-500">*</span>
                  </label>
                  <p-dropdown
                    [options]="getDropdownOptions(field)"
                    [(ngModel)]="customFieldsMap[field.id]"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Selecione"
                    class="w-full"
                    styleClass="w-full"
                  ></p-dropdown>
                </div>

                <!-- CHECKBOX -->
                <div *ngIf="field.fieldType === 'CHECKBOX'" class="flex items-center gap-2">
                  <p-checkbox
                    [(ngModel)]="customFieldsMap[field.id]"
                    [ngModelOptions]="{standalone: true}"
                    [binary]="true"
                  ></p-checkbox>
                  <label class="font-medium">{{ field.label }}</label>
                </div>

              </ng-container>

              <div *ngIf="customFieldDefinitions.length === 0" class="md:col-span-2 text-center text-gray-500 py-8">
                Nenhum campo personalizado configurado.
              </div>
            </div>
          </div>
        </div>
      </p-tabpanel>

      <!-- Aba 4: Serviços -->
      <p-tabpanel header="Serviços">
        <div class="mt-4">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-gray-700">Lista de Serviços</h3>
            <button 
              pButton 
              type="button" 
              icon="pi pi-plus" 
              label="Adicionar Serviço" 
              class="p-button-sm p-button-outlined" 
              (click)="addItem()"
            ></button>
          </div>

          <div formArrayName="items">
            <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-4 items-end bg-gray-50 p-4 rounded">
              
              <div class="md:col-span-5">
                <label class="block mb-1 text-sm font-medium">Serviço <span class="text-red-500">*</span></label>
                <p-dropdown
                  [options]="services"
                  formControlName="serviceId"
                  optionLabel="name"
                  optionValue="id"
                  [filter]="true"
                  filterBy="name"
                  placeholder="Selecione"
                  class="w-full"
                  styleClass="w-full"
                  (onChange)="onServiceChange(i)"
                ></p-dropdown>
              </div>

              <div class="md:col-span-2">
                <label class="block mb-1 text-sm font-medium">Qtd <span class="text-red-500">*</span></label>
                <p-inputNumber
                  formControlName="quantity"
                  [min]="1"
                  (onInput)="calculateItemTotal(i)"
                  class="w-full"
                  [inputStyle]="{ width: '100%' }"
                ></p-inputNumber>
              </div>

              <div class="md:col-span-2">
                <label class="block mb-1 text-sm font-medium">Preço (R$) <span class="text-red-500">*</span></label>
                <p-inputNumber
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  formControlName="price"
                  (onInput)="calculateItemTotal(i)"
                  class="w-full"
                  [inputStyle]="{ width: '100%' }"
                ></p-inputNumber>
              </div>

              <div class="md:col-span-2">
                <label class="block mb-1 text-sm font-medium">Total</label>
                <p-inputNumber
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  formControlName="total"
                  [readonly]="true"
                  class="w-full"
                  [inputStyle]="{ width: '100%', 'background-color': '#e5e7eb' }"
                ></p-inputNumber>
              </div>

              <div class="md:col-span-1 flex justify-center">
                <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="removeItem(i)"></button>
              </div>
            </div>
          </div>

          <div class="border-t border-gray-200 my-4"></div>

          <!-- Totais -->
          <div class="flex flex-col md:flex-row justify-end gap-6">
            <div class="w-full md:w-48">
              <label class="block mb-1 font-medium">Desconto (R$)</label>
              <p-inputNumber
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                formControlName="discount"
                (onInput)="calculateTotal()"
                class="w-full"
                [inputStyle]="{ width: '100%' }"
              ></p-inputNumber>
            </div>
            <div class="w-full md:w-48">
              <label class="block mb-1 font-medium text-lg">Total Final</label>
              <p-inputNumber
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                formControlName="total"
                [readonly]="true"
                class="w-full"
                [inputStyle]="{ width: '100%', 'font-weight': 'bold', 'font-size': '1.2rem', 'color': 'green' }"
              ></p-inputNumber>
            </div>
          </div>
        </div>
      </p-tabpanel>

    </p-tabview>

    <!-- Botões -->
    <div class="flex justify-end gap-3 mt-6">
      <button (click)="goBack()" type="button" class="border px-4 py-2 border-orange-500 cursor-pointer rounded hover:bg-orange-50">Cancelar</button>
      <button
        type="submit"
        class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
        [disabled]="form.invalid"
      >
        {{ isEditMode ? 'Salvar' : 'Criar OS' }}
      </button>
    </div>
  </form>
</div>
<p-toast />
